export const notificationsReducer = (state = {loading: true, resultnotification: null, notifications: null, notification: null, notificationuser: null } , action) => {
    switch (action.type) {
        case 'NOTIFICATION_GET_SUCCESS':
            return {
                ...state,
                loading:false,
                notifications: action.payload.notification
            }
        case 'NOTIFICATION_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'NOTIFICATION_NOT_LOADING':
            return {
                ...state,
                loading:false
            }
        case 'NOTIFICATION_RESET_RESULT':
            return {...state,
                resultnotification: null
            }
        case 'NOTIFICATION_REMOVE_RESULT':
            return {...state,
                loading:false,
                resultnotification: action.payload.message,
                notifications: state.notifications.filter(notifications => notifications._id !== action.payload.notification)
            }
        default:
            return state
    }
}

